import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Account from './components/Account';
import ProtectedRouter from './components/ProtectedRouter';
import ProtectedAdmin from './components/ProtectedAdmin';
import Signin from './components/Signin';
import Signup from './components/Signup';
import RecoverPass from './components/RecoverPass';
import Dashboard from './components/Dashboard';
import HomePage from './components/HomePage';
import PayPal from './components/PayPal';
import { AuthContextProvider } from './context/AuthContext';
import {
  clientTextBox,
  userInputsPersonal,
  userInputsPartner,
  userInputsGeneralQuestions,
  userInputsGeneralQuestionsPartner,
  userInputsEmployment,
  userInputsEmploymentPartner,
  userInputsExpenses,
  userInputsEmploymentExpenses,
  userInputsEmploymentExpensesPartner,
  userInputsExpensesPartner,
  userInputsInvestments,
  userInputsInvestmentsPartner,
  userAuthorize,
  userAuthorizePartner,
  userInputDependants,
  userBankInf,
  userBankInfPartner,
} from './context/FormSource';
import AdminAccount from './components/AdminAccount';

import { withTranslation } from 'react-i18next';

function App({ t }) {
  return (
    <AuthContextProvider>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route
          path="/admin"
          element={
            <ProtectedAdmin>
              <Dashboard />
            </ProtectedAdmin>
          }
        />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/RecoverPass" element={<RecoverPass />} />
        <Route path="/paypal" element={<PayPal />} />
        <Route
          path="/AdminAccount/:id"
          element={
            <ProtectedAdmin>
              <AdminAccount />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRouter>
              <div className="flex-1 bg-slate-00">
                <Account
                  clientTextBox={clientTextBox}
                  userInputsPersonal={userInputsPersonal}
                  userInputsPartner={userInputsPartner}
                  userInputsGeneralQuestions={userInputsGeneralQuestions}
                  userInputsEmployment={userInputsEmployment}
                  userInputsExpenses={userInputsExpenses}
                  userInputsEmploymentExpenses={userInputsEmploymentExpenses}
                  userInputsEmploymentExpensesPartner={
                    userInputsEmploymentExpensesPartner
                  }
                  userInputsInvestments={userInputsInvestments}
                  userAuthorize={userAuthorize}
                  userInputsGeneralQuestionsPartner={
                    userInputsGeneralQuestionsPartner
                  }
                  userInputsEmploymentPartner={userInputsEmploymentPartner}
                  userInputsExpensesPartner={userInputsExpensesPartner}
                  userInputsInvestmentsPartner={userInputsInvestmentsPartner}
                  userAuthorizePartner={userAuthorizePartner}
                  userInputDependants={userInputDependants}
                  userBankInf={userBankInf}
                  userBankInfPartner={userBankInfPartner}
                />
              </div>
            </ProtectedRouter>
          }
        />
        <Route path="*" element={<Navigate to="/signin" replace={true} />} />
      </Routes>
    </AuthContextProvider>
  );
}

export default withTranslation()(App);
